import React from 'react'
import cn from 'classnames'
import { Trans } from '@mc/i18n'
import { BogoTermsLink } from '../../featureVariables'
import { BOGO_I18N_NAMESPACE } from '../../i18n'

export const SeeTerms = ({
  size = 'xs',
  onTermsClick,
}: {
  size?: 'sm' | 'xs'
  onTermsClick?: (linkText: string) => void
}) => (
  <p
    className={cn('mc-text--normal mc-opacity--hinted mc-mb-4', {
      'mc-text-small': size === 'sm',
      'mc-text-x-small': size === 'xs',
    })}
  >
    <Trans i18nKey='common.seeTerms' ns={BOGO_I18N_NAMESPACE}>
      <BogoTermsLink onClick={onTermsClick} />
    </Trans>
  </p>
)
